import { AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { MenuImportService } from '@app/core/services/menu/menu-import.service';
import { LanguageService } from '@app/core/services/translate/language.service';
import { MenuItem } from '@app/shared/models/menu.interface';

@Component({
  selector: 'vfs-menu-entry',
  templateUrl: './menu-entry.component.html',
  styleUrls: ['./menu-entry.component.scss']
})
export class MenuEntryComponent implements AfterViewInit, AfterViewChecked {
  @Input() entry: MenuItem;
  @Input() expanded: boolean;
  @Output() menuEvent = new EventEmitter();
  @Output() toggleMenu = new EventEmitter();

  @ViewChild('trigger') menuTrigger: MatMenuTrigger;
  active: boolean = false;
  entryValue: string;

  constructor(
    private router: Router,
    protected languageService: LanguageService,
    private menuImportService: MenuImportService
  ) { }

  ngAfterViewInit(): void {
    this.entryValue = this.entry?.value ? this.entry.value : this.languageService.getNoTx();
  }

  ngAfterViewChecked(): void {
    this.active = this.isActive();
  }

  importLinkRight(link: string): boolean {
    if (link) {
      if (link.startsWith('imports')) {
        const type = link.slice(link.indexOf('/') + 1);
        return this.menuImportService.hasRight(type);
      }
    }
    return true;
  }

  onLinkClick() {
    const link: string = this.entry.link;
    if (link) {
      if (link.startsWith('imports')) {
        const type = link.slice(link.indexOf('/') + 1);
        this.menuImportService.importFile(type);
      } else {
        if (!this.entry.external) {
          this.router.navigate([link]);
        } else {
          const prefix = link.startsWith('http') ? '' : 'https://';
          window.open(prefix + link, '_blank');
        }
        this.active = this.isActive();
      }
    }

    this.toggleMenu.emit();
  }

  onFolderClick() {
    this.menuTrigger.openMenu();
    this.menuEvent.emit();
  }

  protected isActive(): boolean {
    const link: string = this.entry.link;
    const forms = link.includes('/forms/proxy');
    if (forms) {
      return this.router.isActive(link.split('/proxy')[0], false);
    } else {
      return this.router.isActive(link, false);
    }
  }
}
